import React, { useState } from "react";
import { api } from "../utils/api.ts";
import { Box, Paper, Typography, TextField, Button, Alert } from "@mui/material";

interface Props {
  onLogin: (userData: any) => void;
}

const LoginPage: React.FC<Props> = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      const res = await api.post("/api/login", { username, password });
      // cookie is set by the server (HttpOnly), nothing to store in JS
      onLogin(res.data);
    } catch {
      setError("Invalid credentials");
    }
  };

  return (
    <Box sx={{ height: "100vh", bgcolor: "background.default", display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}>
      <Paper elevation={3} sx={{ width: 360, p: 4, borderRadius: 2 }}>
        <Typography variant="h5" fontWeight={600} gutterBottom>
          Login
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleLogin}>
          <TextField label="Username" fullWidth variant="outlined" value={username} onChange={(e) => setUsername(e.target.value)} margin="normal" required />
          <TextField label="Password" fullWidth variant="outlined" type="password" value={password} onChange={(e) => setPassword(e.target.value)} margin="normal" required />
          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
            Login
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default LoginPage;
